define.alias("shared/components/shared/video-player/controls", "preview-grid/components/shared/video-player/controls");